import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_toggles = _resolveComponent("vue-toggles")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_vue_toggles, {
      value: _ctx.modelValue,
      onClick: _ctx.onClick,
      checkedText: _ctx.checkedText,
      uncheckedText: _ctx.uncheckedText,
      height: _ctx.height,
      width: _ctx.width
    }, null, 8, ["value", "onClick", "checkedText", "uncheckedText", "height", "width"])
  ]))
}